import axios from "axios";
import {ENDPOINT_ADMINISTRATION, ENDPOINT_EXPORT_PERIODIQUE, ENDPOINT_LOGS} from "../constants/endpoints";

let store = {
  debug: true,

  exportPeriodique() {
    return axios.get(`${ENDPOINT_ADMINISTRATION + ENDPOINT_EXPORT_PERIODIQUE}`);
  },

  exportLogs() {
    return axios.get(`${ENDPOINT_ADMINISTRATION + ENDPOINT_LOGS}`);
  }

};

export default store;
